/* Experience switcher — open WhatsApp with a prefilled message.
 *
 * Video Consultation: the form's "Let's find your perfect piece" builds a
 * wa.me link with the entered name + email ({name}/{email} tokens in the
 * message). Try at Home: the button opens WhatsApp with its own message.
 * Client-side, so it works without the App Proxy backend.
 */

(() => {
  // Loaded by more than one section; bind the handlers once.
  if (window.CaratKinExperienceWhatsapp) return;
  window.CaratKinExperienceWhatsapp = true;

  const waLink = (number, message) =>
    'https://wa.me/' + String(number || '').replace(/[^0-9]/g, '') +
    '?text=' + encodeURIComponent(message || '');

  const open = (url) => window.open(url, '_blank', 'noopener');

  // Video consultation form.
  document.addEventListener('submit', (event) => {
    const form = event.target.closest('form[data-wa-consult]');
    if (!form) return;
    event.preventDefault();
    if (form.reportValidity && !form.reportValidity()) return;

    const name = (form.querySelector('[name="name"]') || {}).value || '';
    const email = (form.querySelector('[name="email"]') || {}).value || '';
    const template =
      form.getAttribute('data-wa-template') ||
      "Hi Carat & Kin! I'd like to book a video consultation.\nName: {name}\nEmail: {email}";

    const message = template
      .replace(/\{name\}/gi, name.trim())
      .replace(/\{email\}/gi, email.trim());

    open(waLink(form.getAttribute('data-wa-number'), message));
  });

  // Try at Home button.
  document.addEventListener('click', (event) => {
    const el = event.target.closest('[data-wa-tryhome]');
    if (!el) return;
    event.preventDefault();
    const message =
      el.getAttribute('data-wa-template') ||
      "Hi Carat & Kin! I'm interested in the Try at Home experience.";
    open(waLink(el.getAttribute('data-wa-number'), message));
  });
})();
